import { Component, OnInit, Input, OnDestroy, Output } from '@angular/core';
import { WidgetModel, WidgetInfoModel, InformationModel } from '../../../../core/models/widget.model';
import { HomeService } from 'src/app/home/service/home.service';
import { Router } from '@angular/router';

import moment from 'moment';

@Component({
  selector: 'app-clock',
  templateUrl: './clock.component.html',
  styleUrls: ['./clock.component.scss']
})
export class ClockComponent implements OnInit, OnDestroy {

  private rawInfo: InformationModel[];
  @Input() set info(widgetInfo: InformationModel[]) {
    this.rawInfo = widgetInfo;
    this.processDateTime();
  }

  @Input() public dragged: boolean;
  @Input() public data: WidgetModel;
  @Input() public scrolling: boolean;

  public timer: any;
  public serverDateTime: any;
  public timeHM: string;
  public timeS: string;
  public dateLabel: string;

  constructor(private homeSvc: HomeService,
              private router: Router) { }

  ngOnInit(): void {
    if (this.dragged) {
      this.processServiceDateTime();
      return;
    }
    this.homeSvc.fetchWidgetData(this.data.id);
    this.timer = window.setInterval(() => {
      this.runClock();
    }, 1000);
  }

  ngOnDestroy(): void {
    window.clearInterval(this.timer);
  }

  runClock(): void {
    if (!this.rawInfo || this.rawInfo.length === 0) {
      return;
    }
    this.serverDateTime = this.serverDateTime.add(1, 's');
    this.processDateTime();
    this.homeSvc.storedDateTime = this.serverDateTime;
  }

  processDateTime(): void {
    if (!this.rawInfo || this.rawInfo.length === 0 || !this.rawInfo[0].values) {
      return;
    } else if (this.rawInfo && this.rawInfo.length > 0 && this.rawInfo[0].values.date_now && !this.serverDateTime) {
      this.serverDateTime = moment(this.rawInfo[0].values.date_now).subtract(3, 'h');
    }
    this.timeHM = this.serverDateTime.format('HH:mm');
    this.timeS = this.serverDateTime.format(':ss');
    this.dateLabel = this.serverDateTime.locale('pt').format(`dddd, DD [de] MMMM [de] YYYY`);
  }

  processServiceDateTime(): void {
    const dateTime = moment(this.homeSvc.storedDateTime);
    this.timeHM = dateTime.format('HH:mm');
    this.timeS = dateTime.format(':ss');
    this.dateLabel = dateTime.locale('pt').format(`dddd, DD [de] MMMM [de] YYYY`);
  }
}
